module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1150.873d50bb.png";